import { motion, useTransform } from "framer-motion";
import { edgePath } from "./layout.js";

export function Edge({ px, py, cx, cy, state, C, anchor = "center", mode = "vertical" }) {
  const d = useTransform(
    [px, py, cx, cy],
    (latest) => {
      const [a, b, c, e] = latest;
      return edgePath(a, b, c, e, anchor, anchor, mode);
    }
  );

  const active = state === "active" || state === "flow";
  const stroke = active ? C.accent : C.accentSoft;
  const opacity = state === "dim" ? 0.07 : active ? 1 : 0.85;

  return (
    <g>
      {state === "flow" && (
        <motion.path
          style={{ d }}
          fill="none"
          stroke={C.accent}
          strokeWidth={8}
          opacity={0.28}
          strokeLinecap="round"
        />
      )}
      <motion.path
        style={{ d }}
        fill="none"
        stroke={stroke}
        strokeWidth={active ? 3 : 2.2}
        animate={{ opacity }}
        transition={{ duration: 0.45, ease: "easeOut" }}
        strokeLinecap="round"
        className={state === "flow" ? "edge-flow" : undefined}
        strokeDasharray={state === "flow" ? "1 9" : undefined}
      />
    </g>
  );
}
